import { render, staticRenderFns } from "./AddStudentSimModal.vue?vue&type=template&id=6391b330&scoped=true&"
import script from "./AddStudentSimModal.vue?vue&type=script&lang=js&"
export * from "./AddStudentSimModal.vue?vue&type=script&lang=js&"
import style0 from "./AddStudentSimModal.vue?vue&type=style&index=0&id=6391b330&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6391b330",
  null
  
)

export default component.exports